import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Core2Config } from '../../../shared/core2Config';
import { bl_del_shipment_hdr_RowClass, DeliveryShipmentHdrContainerModel } from '../../../../../../../models';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel } from '../../../shared';
import { Observable } from 'rxjs';
import { BaseApiPublicLoginTemplateService } from '../../../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class ShipmentHdrService extends BaseApiPublicLoginTemplateService<DeliveryShipmentHdrContainerModel, DeliveryShipmentHdrContainerModel, DeliveryShipmentHdrContainerModel> {
  // https://api-test.akaun.com/core2/tnt/dm/del/region-comp-branch-location-links

  //todo: del/ or no del/ ?
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'delivery-shipment-hdr/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'delivery-shipment-hdr/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'delivery-shipment-hdr/backoffice-ep';
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'delivery-shipment-hdr/public-ep';
    this.httpClient = http;
  }

// make post request to get the shipment data for listing
  retrieveShipments(body:any, visa: ApiVisa):Observable<BasicApiResponseModel<any>>{
    let url = ''
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/query';
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(url, body, this.getHttpHeader(visa))
  }

  postWithQueue(dtoObject, visa: ApiVisa) {
    let url = this.apiUrl + '/backoffice-ep' + '/?add_to_queue=true';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '?add_to_queue=true';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  cancelJobs(dtoObject, visa: ApiVisa) {
    let url = this.apiUrl + '/backoffice-ep' + '/cancel-jobs-from-shipment';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/cancel-jobs-from-shipment';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa))
  }

  startJobs(visa: ApiVisa, dtoObject) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/backoffice-ep/start-jobs';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/backoffice-ep/start-jobs';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  startJobsLoginDriver(visa: ApiVisa, dtoObject) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/login-driver-ep/start-jobs';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/login-driver-ep/start-jobs';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  completeJobs(visa: ApiVisa, dtoObject) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/backoffice-ep/complete-jobs';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/backoffice-ep/complete-jobs';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  completeJobsLoginDriver(visa: ApiVisa, dtoObject) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/login-driver-ep/complete-jobs';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/login-driver-ep/complete-jobs';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  readyToShipJobs(visa: ApiVisa, dtoObject) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/backoffice-ep/ready-to-ship';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/backoffice-ep/ready-to-ship';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  addCustomStatusToJobs(visa: ApiVisa, dtoObject) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/add-custom-status/backoffice-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/jobs/add-custom-status/backoffice-ep';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  multiDeleteShipments(dtoObject, visa: ApiVisa) {
    let url = ""
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/delete-multiple';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  getByTrackingIdPublicEp(
    trackingId: string,
    apiVisa: ApiVisa
  ): Observable<ApiResponseModel<bl_del_shipment_hdr_RowClass>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path_public_url;
    }

    apiVisa.applet_code = apiVisa.applet_code ? apiVisa.applet_code : 'none';
    apiVisa.tenantCode = apiVisa.tenantCode
      ? apiVisa.tenantCode
      : '';

    const httpOptions = {
      headers: new HttpHeaders({
        authorization: apiVisa.jwt_secret,
        'Content-Type': 'application/json',
        tenantCode: apiVisa.tenantCode,
        appId: apiVisa.applet_code
      })
    };

    return this.httpClient.get<ApiResponseModel<bl_del_shipment_hdr_RowClass>>(
      this.apiUrl + '/' + trackingId,
      httpOptions
    );
  }
}